import { Box, Typography } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { StyledSelect, StyledSelectOption } from '../../styles';
import { SETTINGS } from '../../variables';

const ProductsSortBy = ({ options }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const sortByParam = searchParams.get('sortBy');

  const handleSortBy = (e) => {
    searchParams.set('sortBy', e.target.value);
    setSearchParams(searchParams);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Typography
        variant='small'
        sx={{
          fontWeight: '700',
        }}
      >
        Ordenar por:
      </Typography>
      <StyledSelect
        value={sortByParam || SETTINGS.defaults.productList.sortBy}
        onChange={handleSortBy}
        size='small'
        autoWidth
      >
        {options.map((type) => (
          <StyledSelectOption
            key={`orderBy-option-${type.id}`}
            value={type.id}
            title={type.text}
          >
            {type.text}
          </StyledSelectOption>
        ))}
      </StyledSelect>
    </Box>
  );
};

export default ProductsSortBy;
